export const order = 2;
export const routes = {
  path: '/',
  name: 'uploadRecordsLayout',
  component: () => import('@/views/layout'),
  meta: {
    title: '上传记录',
    guard: {
      role: ['Admin'],
      permission: ['upms:uploadRecords'],
    },
  },
  children: [
    {
      path: 'uploadRecordsPage',
      name: 'uploadRecordsPage',
      meta: {
        title: '上传记录',
        guard: {
          role: ['Admin'],
          permission: ['upms:uploadRecordsPage'],
        },
      },
      component: () => import('@/views/uploadRecords'),
    },
  ],
};
export const perms = {
  uploadRecordsPage: [
    {
      title: '编辑',
      permission: 'upms:uploadRecordsPage:edit',
    },
    {
      title: '撤回',
      permission: 'upms:uploadRecordsPage:withdraw',
    },
    {
      title: '删除',
      permission: 'upms:uploadRecordsPage:del',
    },
  ],
};
